<template>
  <el-row class="flex-row page-device-manage page-dimension">
    <CompSideTree
      pageName="dimensionManage"
      ref="treeRef"
      :filterTitle="Lang.Text.dimensionAllAuthNode"
      :searchPlaceholder="Lang.Text.dimensionSearchNode"
      :treeOption="treeOption"
      :dimensionType="dimensionType"
      :treeData="treeData"
      :permissionObj="permissionObj"
      :bottomAddText="Lang.Button.dimensionAddNode"
      :showConsumption="false"
      :showDimensionSelect="true"
      :showBottomAdd="true"
      :showDotted="false"
      :showOrgFilter="true"
      @update:treeOption="(val) => (treeOption = val)"
      @nodeClick="nodeClick"
      @add="handleSideTreeAdd"
      @delete="handleDeleteDimensionNode"
      @move="handleClickMoveNode"
      @bottomAdd="handleBottomAddNdoe"
      @updateSideTree="updateSideTree"
      @dimensionChange="handleDimensionChange"
      @organizationChange="handleOrganizationChange"
    />

    <div class="flex-col limitmain">
      <breadcrumb :repeat="true" v-if="website.setting.breadcrumb" />
      <!-- 能源 页面-->
      <basic-card class="new-basic-card" v-if="dimensionType=='AreaEnergy'">
        <div class="page-pannel">
          <!-- 部门信息模块 -->
          <div class="module">
            <div comment="部门" class="pannel-header">
              <div class="pannel-title">
                <comp-svg :name="currentNode.isDept ? 'tree-node' : 'simple-tree-node'"></comp-svg>
                <span class="text">{{ currentNode.name }}</span>
              </div>
              <div class="pannel-buttons">
                <div class="title-right">
                  <comp-svg name="point-green" size="10px" class="point-green"></comp-svg>
                  <span class="update-time">
                  {{ dimensionInfo.dimensionUpdate }}
                  </span>
                </div>
                <comp-button v-if="permissionObj.editNode" size="medium" type="primary" @click="handleEditNode()" >{{ Lang.btn.edit }}</comp-button>
              </div>
            </div>
            <div class="pannel-detail">
              <div class="info-section">
                <div class="info-content">
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionNodeType }}</div>
                    <div class="value">{{ dimensionInfo.nodeTypeName || '- -'  }}</div>
                  </div>
                  <template v-if="dimensionInfo.nodeType == 'meter'">
                    <div class="info-item">
                      <div class="label">{{ Lang.Title.dimensionSequence}}</div>
                      <div class="value">{{ dimensionInfo.sort || '- -'  }}</div>
                    </div>
                  </template>
                  <template v-if="dimensionInfo.nodeType == 'chargingStation'">
                    <div class="info-item">
                      <div class="label">{{ Lang.Text.dimensionChargerNo }}</div>
                      <div class="value">{{ dimensionInfo.totalChargers || '- -'  }}</div>
                    </div>
                    <div class="info-item">
                      <div class="label">{{ Lang.Text.dimensionGunNo }}</div>
                      <div class="value">{{ dimensionInfo.totalConnectors || '- -'  }}</div>
                    </div>
                    <div class="info-item">
                      <div class="label">{{ Lang.Text.dimensionEvcPower }}</div>
                      <div class="value">{{ dimensionInfo.totalOutputPower || '- -'  }}</div>
                    </div>
                  </template>
                </div>
              </div>
            </div>
          </div>
          <!-- 关联设备模块 -->
          <div class="module">
            <div comment="关联设备模块" class="pannel-header">
              <div class="pannel-title">
                <div class="pannel-title-box" v-if="selectedDevice.sn">
                  <comp-svg name="server"></comp-svg>
                  <span class="text">{{ selectedDevice.name }}</span>
                </div>
                <div class="pannel-title-box" v-if="!selectedDevice.sn">
                  <span class="text">{{ Lang.Title.dimensionNoDevice }}</span>
                </div>
                <div class="pannel-sn" v-if="selectedDevice.sn">
                  <label for="" class="sn">SN </label>
                  <value>{{ selectedDevice.sn }}</value>
                </div>
              </div>
              <div class="pannel-buttons">
                <div class="title-right" v-if="selectedDevice.sn">
                  <comp-svg name="point-green" size="10px" class="point-green"></comp-svg>
                  <span class="update-time">
                  {{ selectedDevice.deviceUpdate }}
                  </span>
                </div>
                <comp-button v-if="permissionObj.linkDevice && !selectedDevice.deviceUpdate" type="primary" @click="handleLinkDevice()">{{ Lang.Button.dimensionLinkDevice }}</comp-button>
                <comp-button v-if="permissionObj.linkDevice && selectedDevice.deviceUpdate" type="primary" @click="unLinkDevice()">{{ Lang.Button.dimensionUnlinkDevice }}</comp-button>
              </div>
            </div>
            <div class="pannel-detail" v-if="selectedDevice.sn">
              <div class="info-section">
                <div class="info-content">
                  <div class="info-item">
                    <div class="label">{{ Lang.Button.dimensionDeviceType }}</div>
                    <div class="value">{{ selectedDevice.iotProductName || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionModel }}</div>
                    <div class="value">{{ selectedDevice.modelName == '-1' ? '- -' : selectedDevice.modelName }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionInstallLo }}</div>
                    <div class="value">{{ selectedDevice.address || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionDesc }}</div>
                    <div class="value">{{ selectedDevice.des || '- -'  }}</div>
                  </div>
                </div>
              </div>
            </div>
            <CompEmpty  v-if="!selectedDevice.sn" icon="empty" size="120px" margin="24px"/>
          </div>
        </div>
      </basic-card>
      <!-- 环境 页面-->
      <basic-card class="new-basic-card" v-if="dimensionType=='Environment'">
        <div class="page-pannel">
          <div class="module">
            <div class="pannel-header">
              <div class="pannel-title">
                <comp-svg :name="currentNode.isDept ? 'tree-node' : 'simple-tree-node'"></comp-svg>
                <span class="text">{{ currentNode.name }}</span>
              </div>
              <div class="pannel-buttons">
                <div class="title-right">
                  <comp-svg name="point-green" size="10px" class="point-green"></comp-svg>
                  <span class="update-time">
                  {{ dimensionInfo.dimensionUpdate }}
                  </span>
                </div>
                <comp-button v-if="permissionObj.editNode" size="medium" type="primary" @click="handleEditNode()" >{{ Lang.btn.edit }}</comp-button>
              </div>
            </div>
            <div class="pannel-detail">
              <div class="info-section">
                <div class="info-content">
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionNodeType }}</div>
                    <div class="value">{{ dimensionInfo.nodeTypeName || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionSequence }}</div>
                    <div class="value">{{ dimensionInfo.sort  }}</div>
                  </div>
                  <div class="info-item" v-if="['MainMonitoringZone','SubMonitoringZone'].includes(dimensionInfo.nodeType)">
                    <div class="label">{{ Lang.Title.dimensionZoneLayput }}</div>
                    <div class="value" v-if="dimensionInfo.picture">
                      <CompImagePreview :src="dimensionInfo.picture" />
                    </div>
                  </div>
                  <div class="info-item" v-if="['MonitoringGroup'].includes(dimensionInfo.nodeType)">
                    <div class="label">{{ Lang.Title.dimensionMainZoneCoor }}</div>
                    <div class="value">
                      <span style="margin-right: 16px;">X:{{ dimensionInfo.xaxis || '- -'  }}</span>
                      <span>Y:{{ dimensionInfo.yaxis || '- -'  }}</span>
                    </div>
                  </div>
                  <div class="info-item" v-if="['MonitoringGroup'].includes(dimensionInfo.nodeType)">
                    <div class="label">{{ Lang.Title.dimensionSubZoneCoor }}</div>
                    <div class="value">
                      <span style="margin-right: 16px;">X:{{ dimensionInfo.yaxis || '- -'  }}</span>
                      <span>Y:{{ dimensionInfo.yaxisSub || '- -'  }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="module">
            <div comment="关联设备模块" class="pannel-header">
              <div class="pannel-title">
                <div class="pannel-title-box" v-if="selectedDevice.sn">
                  <comp-svg name="server"></comp-svg>
                  <span class="text">{{ selectedDevice.name }}</span>
                </div>
                <div class="pannel-title-box" v-if="!selectedDevice.sn">
                  <span class="text">{{ Lang.Title.dimensionNoDevice }}</span>
                </div>
                <div class="pannel-sn" v-if="selectedDevice.sn">
                  <label for="" class="sn">SN </label>
                  <value>{{ selectedDevice.sn }}</value>
                </div>
              </div>
              <div class="pannel-buttons">
                <div class="title-right" v-if="selectedDevice.sn">
                  <comp-svg name="point-green" size="10px" class="point-green"></comp-svg>
                  <span class="update-time">
                  {{ selectedDevice.deviceUpdate }}
                  </span>
                </div>
                <comp-button v-if="permissionObj.linkDevice && !selectedDevice.deviceUpdate" type="primary" @click="handleLinkDevice()">{{ Lang.Button.dimensionLinkDevice }}</comp-button>
                <comp-button v-if="permissionObj.linkDevice && selectedDevice.deviceUpdate" type="primary" @click="unLinkDevice()">{{ Lang.Button.dimensionUnlinkDevice }}</comp-button>
              </div>
            </div>
            <div class="pannel-detail" v-if="selectedDevice.sn">
              <div class="info-section">
                <div class="info-content">
                  <div class="info-item">
                    <div class="label">{{ Lang.Button.dimensionDeviceType }}</div>
                    <div class="value">{{ selectedDevice.iotProductName || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionModel }}</div>
                    <div class="value">{{ selectedDevice.modelName == '-1' ? '- -' : selectedDevice.modelName }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionInstallLo }}</div>
                    <div class="value">{{ selectedDevice.address || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionDesc }}</div>
                    <div class="value">{{ selectedDevice.des || '- -'  }}</div>
                  </div>
                </div>
              </div>
            </div>

            <el-dialog
              class="global-dialog"
              top="40vh"
              width="70%"
              draggable
              destroy-on-close
              :close-on-click-modal="false"
              v-model="dialogVisible">
              <el-image style="width: 100%; height: 100%; border-radius: 2px;" :src="dialogImageUrl" fit="fit" />
            </el-dialog>
            <CompEmpty  v-if="!selectedDevice.sn" icon="empty" size="120px" margin="24px"/>
          </div>
        </div>
      </basic-card>

      <!-- 光伏 页面-->
      <basic-card class="new-basic-card" v-if="dimensionType=='Photovoltaic'">
        <div class="page-pannel">
          <div class="module">
            <div class="pannel-header">
              <div class="pannel-title">
                <comp-svg :name="currentNode.isDept ? 'tree-node' : 'simple-tree-node'"></comp-svg>
                <span class="text">{{ currentNode.name }}</span>
              </div>
              <div class="pannel-buttons">
                <div class="title-right">
                  <comp-svg name="point-green" size="10px" class="point-green"></comp-svg>
                  <span class="update-time">
                  {{ dimensionInfo.dimensionUpdate }}
                  </span>
                </div>
                <comp-button v-if="permissionObj.editNode" size="medium" type="primary" @click="handleEditNode()" >{{ Lang.btn.edit }}</comp-button>
              </div>
            </div>
            
            <div class="pannel-detail">
              <div class="info-section">
                <div class="info-content">
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionNodeType }}</div>
                    <div class="value">{{ dimensionInfo.nodeTypeName || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionSequence }}</div>
                    <div class="value">{{ dimensionInfo.sort  }}</div>
                  </div>
                  <template v-if="['station'].includes(dimensionInfo.nodeType)">
                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionCapacityKwp }}</div>
                      <div class="value">{{ dimensionInfo.capacity  || '- -' }}</div>
                    </div>

                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionInverterNo }}</div>
                      <div class="value">{{ dimensionInfo.inverterCount  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionGridConType }}</div>
                      <div class="value">{{ dimensionInfo.gridTypeName  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionStationRegion }}</div>
                      <div class="value">{{ dimensionInfo.regionName  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionStationAdd }}</div>
                      <div class="value">{{ dimensionInfo.address  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionOpDate }}</div>
                      <div class="value">{{ dimensionInfo.operationDate  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ getCurrencyTitle() }}</div>
                      <div class="value">{{ dimensionInfo.generationPrice  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionGridFeedin }}</div>
                      <div class="value">{{ dimensionInfo.gridEleRtuName  || '- -' }}</div>
                      <div class="value">{{ dimensionInfo.gridEleItemName  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ Lang.Title.dimensionPvToEss }}</div>
                      <div class="value">{{ dimensionInfo.pvBessRtuName  || '- -' }}</div>
                      <div class="value">{{ dimensionInfo.pvBessItemName  || '- -' }}</div>
                    </div>
                    <div class="info-item" >
                      <div class="label">{{ Lang.label.pvsttdbSelfconsumpelec }}</div>
                      <div class="value">{{ dimensionInfo.selfEleRtuName  || '- -' }}</div>
                      <div class="value">{{ dimensionInfo.selfEleItemName  || '- -' }}</div>
                    </div>

                  </template>

                  <div class="info-item" v-if="['inverter'].includes(dimensionInfo.nodeType)">
                    <div class="label">{{ Lang.Title.dimensionCapacityKwp }}</div>
                    <div class="value">{{ dimensionInfo.capacity  }}</div>
                  </div>
                  <div class="info-item" v-if="['inverter'].includes(dimensionInfo.nodeType)">
                    <div class="label">{{ Lang.Title.dimensionRatedOpPower }} (kW)</div>
                    <div class="value">{{ dimensionInfo.ratedOutputPower  }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          
          <div class="module">
            <div comment="关联设备模块" class="pannel-header">
              <div class="pannel-title">
                <div class="pannel-title-box" v-if="selectedDevice.sn">
                  <comp-svg name="server"></comp-svg>
                  <span class="text">{{ selectedDevice.name }}</span>
                </div>
                <div class="pannel-title-box" v-if="!selectedDevice.sn">
                  <span class="text">{{ Lang.Title.dimensionNoDevice }}</span>
                </div>
                <div class="pannel-sn" v-if="selectedDevice.sn">
                  <label for="" class="sn">SN </label>
                  <value>{{ selectedDevice.sn }}</value>
                </div>
              </div>
              <div class="pannel-buttons">
                <div class="title-right" v-if="selectedDevice.sn">
                  <comp-svg name="point-green" size="10px" class="point-green"></comp-svg>
                  <span class="update-time">
                  {{ selectedDevice.deviceUpdate }}
                  </span>
                </div>
                <comp-button v-if="permissionObj.linkDevice && !selectedDevice.deviceUpdate" type="primary" @click="handleLinkDevice()">{{ Lang.Button.dimensionLinkDevice }}</comp-button>
                <comp-button v-if="permissionObj.linkDevice && selectedDevice.deviceUpdate" type="primary" @click="unLinkDevice()">{{ Lang.Button.dimensionUnlinkDevice }}</comp-button>
              </div>
            </div>
            <div class="pannel-detail" v-if="selectedDevice.sn">
              <div class="info-section">
                <div class="info-content">
                  <div class="info-item">
                    <div class="label">{{ Lang.Button.dimensionDeviceType }}</div>
                    <div class="value">{{ selectedDevice.iotProductName || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionModel }}</div>
                    <div class="value">{{ selectedDevice.modelName == '-1' ? '- -' : selectedDevice.modelName }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionInstallLo }}</div>
                    <div class="value">{{ selectedDevice.address || '- -'  }}</div>
                  </div>
                  <div class="info-item">
                    <div class="label">{{ Lang.Title.dimensionDesc }}</div>
                    <div class="value">{{ selectedDevice.des || '- -'  }}</div>
                  </div>
                </div>
              </div>
            </div>
            <CompEmpty  v-if="!selectedDevice.sn" icon="empty" size="120px" margin="24px"/>
          </div>
        </div>
      </basic-card>
    </div>

    <!-- 添加能源节点弹窗 -->
    <el-dialog
      :title="operationType == 'add' ? Lang.Button.dimensionAddNode : Lang.Button.dimensionEdit"
      append-to-body
      class="global-dialog"
      :close-on-click-modal="false"
      v-model="energyDialogBox"
      size="70%"
    >
      <avue-form
        v-if="energyDialogBox"
        :option="energyFormOption"
        class="dialog-custom-class-sort"
        ref="energyFormRef"
        v-model="energyForm"
        >
      </avue-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="large" @click="energyDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button size="large" type="primary" @click="handleSubmitEnergy">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 添加环境节点弹窗 -->
    <el-dialog
      :title="operationType == 'add' ? Lang.Button.dimensionAddNode : Lang.Button.dimensionEdit"
      append-to-body
      center
      :close-on-click-modal="false"
      class="global-dialog"
      v-model="environmentDialogBox"
    >
      <avue-form
        v-if="environmentDialogBox"
        :option="environmentFormOption"
        v-model="environmentForm"
        @submit="handleSubmitEnvironment"
        ref="environmentFormRef"
        >
        <template #picture>
          <CompUpload
            defaultPic
            :formData="environmentForm"
            :disabled="operationType=='view'"
            @change="handleUploadUpdate"
            v-model="environmentForm.picture"
          />
        </template>
        <template #mainZone>
          <div class="global-flex-between-center">
            <el-form-item
              style="width: 100%;"
              prop="xaxis"
              :rules="[{ validator: validateMax7Digits, trigger: 'blur' }]"
            >
              <el-input
                maxlength="7"
                :placeholder="Lang.tips.plzInput + ' ' + Lang.Title.dimensionSubZoneCoor"
                v-model="environmentForm.xaxis"
                @input="handleInput($event, 'xaxis')"
                style="margin-right: 8px;"
              >
                <template #prepend>X</template>
              </el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%;"
              prop="yaxis"
              :rules="[{ validator: validateMax7Digits, trigger: 'blur' }]"
            >
              <el-input
                maxlength="7"
                :placeholder="Lang.tips.plzInput + ' ' + Lang.Title.dimensionSubZoneCoor"
                v-model="environmentForm.yaxis"
                @input="handleInput($event, 'yaxis')"
              >
                <template #prepend>Y</template>
              </el-input>
            </el-form-item>
          </div>
        </template>

        <template #subZone>
          <div class="global-flex-between-center">
            <el-form-item
              style="width: 100%;"
              prop="xaxisSub"
              :rules="[{ validator: validateMax7Digits, trigger: 'blur' }]"
            >
              <el-input
                maxlength="7"
                :placeholder="Lang.tips.plzInput + ' ' + Lang.Title.dimensionSubZoneCoor"
                v-model="environmentForm.xaxisSub"
                @input="handleInput($event, 'xaxisSub')"
                style="margin-right: 8px;"
              >
                <template #prepend>X</template>
              </el-input>
            </el-form-item>
            <el-form-item
              style="width: 100%;"
              prop="yaxisSub"
              :rules="[{ validator: validateMax7Digits, trigger: 'blur' }]"
            >
              <el-input
                maxlength="7"
                :placeholder="Lang.tips.plzInput + ' ' + Lang.Title.dimensionSubZoneCoor"
                v-model="environmentForm.yaxisSub"
                @input="handleInput($event, 'yaxisSub')"
              >
                <template #prepend>Y</template>
              </el-input>
            </el-form-item>
          </div>
        </template>
      </avue-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="large" @click="environmentDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button size="large" type="primary" @click="() => { this.$refs.environmentFormRef.submit() }">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 添加光伏节点弹窗 -->
    <el-dialog
      :title="operationType == 'add' ? Lang.Button.dimensionAddNode : Lang.Button.dimensionEdit"
      append-to-body
      center
      :close-on-click-modal="false"
      class="global-dialog"
      v-model="pvDialogBox"
    >
      <avue-form
        v-if="pvDialogBox"
        :option="pvFormOption"
        v-model="pvForm"
        @submit="handleSubmitPV"
        ref="pvFormRef"
        >
        <template #gridElectricity>
          <div :class="{'global-flex-between-center': !!pvForm.gridEleRtuName}">
            <el-form-item  style="width: 100%; margin-right: 12px;" prop="gridEleRtuId" 
              :rules="[{ required: false, message: Lang.tips.plzSelect, trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%;"
                clearable
                v-model="pvForm.gridEleRtuName"
                @click="handleSelectDevice('gridEleRtuId', 'gridEleRtuName', 'gridEleItemId', 'gridEleItemName')"
                :placeholder="Lang.tips.plzSelect"
              />
            </el-form-item>
            <el-form-item style="width: 100%;" prop="gridEleItemId"
              v-if="pvForm.gridEleRtuName"
              :rules="[{ required: !!pvForm.gridEleRtuName, message: Lang.tips.plzSelect, trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%;"
                clearable
                v-model="pvForm.gridEleItemName"
                @click="handleSelectRtu('gridEleItemId', 'gridEleItemName', 'gridEleRtuId')"
                @clear="handleClearRtu('gridEleItemId', 'gridEleItemName', 'gridEleRtuId')"
                :placeholder="Lang.tips.plzSelect"
              />
            </el-form-item>
          </div>
        </template>
        <template #pvBess>
          <div :class="{'global-flex-between-center': !!pvForm.pvBessRtuName}">
            <el-form-item  style="width: 100%; margin-right: 12px;" prop="pvBessRtuId" 
              :rules="[{ required: false, message: Lang.tips.plzSelect, trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%;"
                clearable
                v-model="pvForm.pvBessRtuName"
                @click="handleSelectDevice('pvBessRtuId', 'pvBessRtuName', 'pvBessItemId', 'pvBessItemName')"
                :placeholder="Lang.tips.plzSelect"
              />
            </el-form-item>
            <el-form-item style="width: 100%;" prop="pvBessItemId"
              v-if="pvForm.pvBessRtuName"
              :rules="[{ required: !!pvForm.pvBessRtuName, message: Lang.tips.plzSelect, trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%;"
                clearable
                v-model="pvForm.pvBessItemName"
                @click="handleSelectRtu('pvBessItemId', 'pvBessItemName', 'pvBessRtuId')"
                @clear="handleClearRtu('pvBessItemId', 'pvBessItemName', 'pvBessRtuId')"
                :placeholder="Lang.tips.plzSelect"
              />
            </el-form-item>
          </div>
        </template>
        <template #selfElectricity>
          <div :class="{'global-flex-between-center': !!pvForm.selfEleRtuName}">
            <el-form-item  style="width: 100%; margin-right: 12px;" prop="selfEleRtuId" 
              :rules="[{ required: false, message: Lang.tips.plzSelect, trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%;"
                clearable
                v-model="pvForm.selfEleRtuName"
                @click="handleSelectDevice('selfEleRtuId', 'selfEleRtuName', 'selfEleItemId', 'selfEleItemName')"
                :placeholder="Lang.tips.plzSelect"
              />
            </el-form-item>
            <el-form-item style="width: 100%;" prop="selfEleItemId"
              v-if="pvForm.selfEleRtuName"
              :rules="[{ required: !!pvForm.selfEleRtuName, message: Lang.tips.plzSelect, trigger: 'blur' }]"
            >
              <el-select
                style="width: 100%;"
                clearable
                v-model="pvForm.selfEleItemName"
                @click="handleSelectRtu('selfEleItemId', 'selfEleItemName', 'selfEleRtuId')"
                @clear="handleClearRtu('selfEleItemId', 'selfEleItemName', 'selfEleRtuId')"
                :placeholder="Lang.tips.plzSelect"
              />
            </el-form-item>
          </div>
        </template>
        <template #region>
          <el-cascader 
            :disabled="operationType=='view'"
            v-model="pvForm.region"
            :props="cascaderProps"
            :lazy="true"
            :show-all-levels="true"
            :lazy-load="loadRegionData"
            :placeholder="Lang.tips.plzSelectRegion"
            @change="handleRegionChange"
            clearable
            style="width: 100%;"
          />
        </template>
      </avue-form>
      <template #footer>
        <div class="dialog-footer">
          <el-button size="large" @click="pvDialogBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button size="large" type="primary" @click="submitPvForm">{{ Lang.btn.confirm }}</el-button>
        </div>
      </template>
    </el-dialog>

    <!-- 移动维度节点 能耗 环境 光伏 -->
    <el-dialog
      :title="Lang.Title.dimensionMoveNode"
      append-to-body
      :close-on-click-modal="false"
      v-model="moveToAnOtherNodeBox"
      size="70%"
      class="global-dialog"
    >
      <el-form v-model="currentNodeForm" >
        <template v-if="dimensionType">
          <el-form-item :label="Lang.Title.dimensionNode" labelPosition="top">
            {{ currentNodeForm.name }}
          </el-form-item>
          <el-form-item :label="Lang.Title.dimensionSourcePath" labelPosition="top">
            {{ currentNodeParentData?.name +  '>' + currentNodeForm.name }}
          </el-form-item>
          <el-form-item :label="Lang.Title.dimensionTargetPath" labelPosition="top">
            <CompTreeSelect
              v-model="currentNodeForm.destinitionId"
              :tree-data="treeData"
              :treeProps="{
                children: 'children',
                label: 'name',
                value: 'id',
              }"
              node-key="id"
              :placeholder="Lang.tips.plzSelect+' '+Lang.Title.dimensionTargetPath"
              @change="handleMoveNodeChange"
            />
          </el-form-item>
        </template>
      </el-form>
      <template #footer>
        <span class="dialog-footer">
          <el-button size="large" @click="moveToAnOtherNodeBox = false">{{ Lang.btn.cancel }}</el-button>
          <el-button size="large" type="primary" @click="handleSubmitMoveNode()">{{ Lang.btn.confirm }}</el-button>
        </span>
      </template>
    </el-dialog>

    <!-- 关联设备 -->
    <SelectDeviceDialog
      v-if="selectDeviceDialog"
      :dimensionType="dimensionType"
      :deptId="organization"
      ref="linkDeviceRef"
      :title="Lang.Title.dimensionLinkDevice"
      @onConfirmSelectDevice="onConfirmSelectLinkDevice"
      @onCancel="selectDeviceDialog=false"
    />

    <!-- 光伏 选择设备 -->
    <SelectDeviceDialog
      v-if="showSelectDevice"
      :dimensionType="dimensionType"
      :deptId="organization"
      ref="selectDeviceRef"
      :title="Lang.Title.dimensionLinkDevice"
      @onConfirmSelectDevice="confirmSelectDevice"
      @onCancel="showSelectDevice=false"
    />
    <!-- 光伏 选择测量点 -->
    <SelectMeasurementPointDialog
      v-if="showSelectRtu"
      :dimensionType="dimensionType"
      :rtuId="currentSelectDevice?.id"
      ref="selectPointRef"
      @confirmSelectRtu="confirmSelectRtu"
      @onCancel="showSelectRtu=false"
    />

  </el-row>
</template>

<script>
import { 
  dimensionTree,
  moveDimensionNode,
  deleteDimensionNode,
  energylDimensionDetail,
  dimensionLinkDevice,
  dimensionUnLinkDevice,
  saveEnergyDimensionInfo,
  updateEnergyDimensionInfo,
  saveEnvironmentInfo,
  updateEnvironmentInfo,
  detailEnvironmentDimension,
  updatePvStationDimensionInfo,
  savePvStationDimensionInfo,
  stationDimensionDetail,
 } from '@/api/system/dimension';

import CompUpload from '@/components/comp-upload/index';
import SelectDeviceDialog from './comps/SelectDeviceDialog.vue';
import SelectMeasurementPointDialog from './comps/SelectMeasurementPointDialog.vue';
// import { getPage as getDevicePage, } from '@/api/gateway/data';
import { getLazyTree } from '@/api/base/region';

import { mapGetters } from 'vuex';
import func from '@/utils/func';
import { defineAsyncComponent } from 'vue';
import { filterDollarKeys } from '@/utils/util';
import { 
  validateAssetId,
  validateMax10DigtsWithPoint,
  validateMax5DigtsWithPoint,
  validateMax10DigtsWith3Point,
  validateMax7Digits,
  validateInt, validateMax10Digits } from '@/utils/validator';
import { Lang } from '@/lang/lang';

import CompTable from '@/components/comp-table/index.vue';
import SelectGateway from './comps/SelectGateway.vue';
import CompTreeSelect from '@/components/comp-tree-select';
import CompSideTree from '@/components/comp-side-tree/index.vue';
import CompEmpty from '@/components/comp-empty/index.vue';
import CompImagePreview from '@/components/comp-image-preview/index.vue';





export default {
  components: {
    CompTable,
    compTabs: defineAsyncComponent(() => import('@/components/comp-tab/index.vue')), // 懒加载,
    SelectGateway,
    CompTreeSelect,
    CompSideTree,
    CompEmpty,
    CompUpload,
    CompImagePreview,
    SelectDeviceDialog,
    SelectMeasurementPointDialog,
  },
  data() {
    return {
      validateMax10Digits: validateMax10Digits,
      form: {},
      cascaderProps: {
        value: 'id',      // 使用 'id' 作为 value
        label: 'title',   // 数据里是 'title' 而不是 'label'
        children: 'children',
        lazy: true,
        leaf: 'isLeaf',   // 指定叶子节点判断字段
        lazyLoad: this.loadRegionData, // 懒加载方法
      },
      dimensionType: 'AreaEnergy', // 默认能源管理
      isShowEnergy: true,
      organization: '',
      dimensionInfo: {},
      operationType: '',
      search: {},
      currentSelectDevice: {},
      refreshIng: false,
      showSelectDevice: false,
      showSelectRtu: false,
      selectDeviceDialog: false,
      moveToAnOtherNodeBox: false,
      auditMode: false,
      query: {},
      loading: true,
      dialogVisible: false,
      selectedDevice: {},
      currentNode: {},

      measurementPointSettingDialogBox: false,
      measurementPointSettingForm: {
        dataSource: '',
        calculationFormula: ''
      },

      energyDialogBox: false,
      energyForm: {
        gatewayType: 1, // 1网关分组,2网关
        tenantId: this.userInfo?.tenant_id,
      },
      energyFormOption: {
        gutter: 20,
        emptyBtn: false,
        submitBtn: false,
        labelPosition: 'top',
        labelSuffix: ' ',
        column: [
          {
            label: this.Lang.Title.dimensionNodeName,
            prop: 'name',
            maxlength: 100,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionNodeName,
                trigger: 'click',
              },
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionNodeType,
            prop: 'nodeType',
            maxlength: 100,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=energyNodeType',
            nodeKey: 'id',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: false, // 如果编辑时有关联设备则必选
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionNodeType,
                trigger: 'click',
              },
            ],
            span: 24,
            onChange: ({value}) => {
              this.energyForm.nodeType = value;
              this.toggleEnergyCols()
            }
          },
          {
            label: this.Lang.Title.dimensionSequence,
            prop: 'sort',
            maxlength: 5,
            type: 'number',
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { required: false, trigger: 'blur' },
              { required: false, validator: validateInt, trigger: 'blur' }
            ],
            span: 24,
          },
          // 充电站类型
          {
            label: this.Lang.Text.dimensionChargerNo,
            prop: 'totalChargers',
            maxlength: 5,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { 
                required: false,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Text.dimensionChargerNo,
                trigger: 'blur'
              },
              { required: false, validator: validateInt, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Text.dimensionGunNo,
            prop: 'totalConnectors',
            maxlength: 5,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { 
                required: false,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Text.dimensionGunNo,
                trigger: 'blur'
              },
              { required: false, validator: validateInt, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Text.dimensionEvcPower + ' (kW)',
            prop: 'totalOutputPower',
            maxlength: 6,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Text.dimensionEvcPower,
                trigger: 'blur',
              },
              { required: false, validator: validateMax5DigtsWithPoint, trigger: 'blur' }
            ],
            span: 24,
          },
        ],
      },

      environmentDialogBox: false,
      environmentForm: {
        tenantId: this.userInfo?.tenant_id,
        picture: '',
      },
      environmentFormOption: {
        emptyBtn: false,
        submitBtn: false,
        gutter: 20,
        labelPosition: 'top',
        labelSuffix: ' ',
        column: [
          {
            label: this.Lang.Title.dimensionNodeName,
            prop: 'name',
            maxlength: 100,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionNodeName,
                trigger: 'click',
              },
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionNodeType,
            prop: 'nodeType',
            maxlength: 100,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=environmentNodeType',
            nodeKey: 'id',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: false, // 如果编辑时有关联设备则必选
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionNodeType,
                trigger: 'click',
              },
            ],
            span: 24,
            onChange: ({value}) => {
              this.environmentForm.nodeType = value;
              this.toggleEnvironmentCols()
            }
          },
          {
            label: this.Lang.Title.dimensionSequence,
            prop: 'sort',
            maxlength: 5,
            type: 'number',
            min: 0,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { required: false, trigger: 'blur' },
              { required: false, validator: validateInt, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionZoneLayput,
            prop: 'picture',
            slot: true,
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionMainZoneCoor,
            prop: 'mainZone',
            maxlength: 10,
            min: 0,
            hide: false,
            slot: true,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { required: false, trigger: 'blur' },
              { required: false, validator: validateMax10Digits, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionSubZoneCoor,
            prop: 'subZone',
            maxlength: 10,
            min: 0,
            hide: false,
            slot: true,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { required: false, trigger: 'blur' },
              { required: false, validator: validateMax10Digits, trigger: 'blur' }
            ],
            span: 24,
          },
        ],
      },

      pvForm: {
        tenantId: this.userInfo?.tenant_id,
      },
      pvDialogBox: false,
      pvFormOption: {
        emptyBtn: false,
        submitBtn: false,
        gutter: 20,
        labelSuffix: ' ',
        labelPosition: 'top',
        labelTipPlacement: 'top-start',
        column: [
          {
            label: this.Lang.Title.dimensionNodeName,
            prop: 'name',
            maxlength: 100,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionNodeName,
                trigger: 'blur',
              },
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionNodeType,
            prop: 'nodeType',
            maxlength: 100,
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=pvmsNodeType',
            nodeKey: 'id',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: false, // 如果编辑时有关联设备则必选
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionNodeType,
                trigger: 'click',
              },
            ],
            span: 24,
            onChange: ({value}) => {
              this.pvForm.nodeType = value;
              this.togglePvCols()
            }
          },
          {
            label: this.Lang.Title.dimensionSequence,
            prop: 'sort',
            maxlength: 5,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { required: false, trigger: 'blur' },
              { required: false, validator: validateInt, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionCapacityKwp,
            prop: 'capacity',
            maxlength: 11,
            rules: [
              {
                required: true,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Title.dimensionCapacityKwp,
                trigger: 'blur',
              },
              { required: false, validator: validateMax10DigtsWith3Point, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionRatedOpPower+ ' (kW)',
            prop: 'ratedOutputPower',
            maxlength: 6,
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Title.dimensionRatedOpPower,
                trigger: 'blur',
              },
              { required: false, validator: validateMax5DigtsWithPoint, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionInverterNo,
            prop: 'inverterCount',
            maxlength: 5,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { 
                required: false,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Title.dimensionInverterNo,
                trigger: 'blur'
              },
              { required: false, validator: validateInt, trigger: 'blur' }
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionGridConType,
            prop: 'gridType',
            type: 'select',
            dicUrl: '/blade-system/dict/dictionary?code=PVMSGridType',
            nodeKey: 'id',
            props: {
              label: 'i18nValue',
              value: 'dictKey',
            },
            rules: [
              {
                required: false,
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionGridConType,
                trigger: 'click',
              },
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionStationRegion,
            prop: 'region',
            slot: true,
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionStationAdd,
            prop: 'address',
            maxlength: 200,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [{ required: false, trigger: 'blur' }],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionOpDate,
            prop: 'operationDate',
            type: 'date',
            format: 'YYYY-MM-DD',
            valueFormat: 'YYYY-MM-DD',
            maxlength: 200,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { 
                required: false,
                message: this.Lang.tips.plzSelect + ' ' + this.Lang.Title.dimensionOpDate,
                trigger: 'blur',
              }
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionGenUnitPrice,
            prop: 'generationPrice',
            maxlength: 16,
            hide: false,
            editDisplay: true,
            viewDisplay: true,
            rules: [
              { 
                required: false,
                message: this.Lang.tips.plzInput + ' ' + this.Lang.Title.dimensionGenUnitPrice,
                trigger: 'blur',
              },
              {
                required: false,
                validator: validateMax10DigtsWithPoint, // 使用自定义校验规则
                trigger: 'blur',
              },
            ],
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionGridFeedin,
            prop: 'gridElectricity',
            slot: true,
            span: 24,
          },
          {
            label: this.Lang.Title.dimensionPvToEss,
            prop: 'pvBess',
            slot: true,
            span: 24,
          },
          {
            label: this.Lang.label.pvsttdbSelfconsumpelec,
            prop: 'selfElectricity',
            slot: true,
            span: 24,
          },
        ],
      },

      moveToAnOtherNodeBox: false,
      currentNodeForm: {},
      currentNodeParentData: {},
      lastUpdateTime: '',
      page: {
        pageSize: 10,
        currentPage: 1,
        total: 0,
      },
      props: {
        label: 'title',
        value: 'key',
      },
      treeData: [],
      treeOption: {
        nodeKey: 'id',
        lazy: false,
        filter: false,
        defaultExpandAll: true,
        addBtn: false,
        editBtn: false,
        delBtn: false,
        filter: false,
        menu: true,
        size: 'small',
        props: {
          labelText: this.Lang.tips.title,
          label: 'name',
          value: 'id', // 选中关键
          children: 'children',
        },
      },
    };
  },
  computed: {
    ...mapGetters(['menuItem', 'permission', 'userInfo']),
    permissionObj() {
      const keys = Object.keys(this.permission)
      const obj = {}
      const menuId = this.menuItem.id;
      keys.forEach((key => {
        if (key.indexOf(menuId) > -1) {
          const btnType = key.substr(menuId.length);
          obj[btnType] = true;
        }
      }))
      console.log('页面权限', obj)
      return obj
    },
  },
  mounted() {
    this.initData(this.userInfo.tenant_id);
    this.updatePvPriceLabel()
  },
  methods: {
    updatePvPriceLabel() {
      this.pvFormOption.column.forEach(col => {
        if (col.prop === 'generationPrice') {
          col.label = this.getCurrencyTitle()
        }
      })
    },
    getCurrencyTitle() {
      return this.Lang.Title.dimensionGenUnitPrice.replace('{货币}', this.userInfo?.tenant_currency_code);
    },
    handleSelectDevice(valueKey, labelKey, childValueKey, childLabelKey) {
      this.selectDeviceValueKey = valueKey;
      this.selectDeviceLabelKey = labelKey;
      this.pvForm[childValueKey] = '';
      this.pvForm[childLabelKey] = '';
      this.showSelectDevice = true;
    },
    confirmSelectDevice(list){
      this.currentSelectDevice = list[0];
      this.pvForm[this.selectDeviceValueKey] = list[0].id;
      this.pvForm[this.selectDeviceLabelKey] = list[0].name;
      this.showSelectDevice = false;
    },
    handleSelectRtu(valueKey, labelKey, parentIdKey) {
      this.selectRtuValueKey = valueKey;
      this.selectRtuLabelKey = labelKey;
      this.currentSelectDevice.id = this.pvForm[parentIdKey] || this.dimensionInfo[parentIdKey];
      this.showSelectRtu = true;
    },
    handleClearRtu(valueKey, labelKey, parentIdKey) {
      this.pvForm[valueKey] = '';
      this.pvForm[labelKey] = '';
    },
    confirmSelectRtu(list){
      // this.selectedRtu = list;
      this.pvForm[this.selectRtuValueKey] = list[0].id;
      this.pvForm[this.selectRtuLabelKey] = list[0].name;
      this.showSelectRtu = false;
    },
    loadRegionData(node, resolve) {
      const parentCode = node.level === 0 ? '00' : node.value;
      getLazyTree(parentCode).then((res) => {
        const data = res.data.data || [];
        resolve(data.map((item) => ({
          id: item.id,           // 确保和 cascaderProps.value 一致
          title: item.title,     // 确保和 cascaderProps.label 一致
          isLeaf: !item.hasChildren,
        })));
      });
    },
    handleRegionChange(value, selectedData) {
      // 处理地区变化
      console.log('地区变化:', value);
      this.pvForm.region = value;
    },
    // 链接设备
    handleLinkDevice() {
      if (!this.currentNode.nodeType || this.currentNode.nodeType == 'dept') { // 部门类型也弹
        this.$dialog({
          title: this.Lang.Title.dimensionLinkDevice,
          content: this.Lang.tips.configNodeTypeFirst,
          confirmButtonText: this.Lang.btn.goToSetting,
          cancelButtonText: this.Lang.btn.cancel,
          showClose: false,
        })
          .then((res) => {
            this.handleEditNode()
          })
      } else {
        this.selectDeviceDialog = true;
      }
    },
    handleInput(value, field) {
      const filterValue = value.replace(/\D/g, ''); // 替换非数字字符为空
      this.environmentForm[field] = filterValue; // 更新对应字段的值
    },
    // 解绑设备
    unLinkDevice() {
      this.$dialog({
        title: this.Lang.Title.dimensionUnlinkDevice,
        titleStyle: 'font-weight:600; margin: 10px 0 0 0;',
        content: this.Lang.Text.dimensionUnlinkDeviceCon,
        confirmButtonText: this.Lang.btn.confirm,
        cancelButtonText: this.Lang.btn.cancel,
        showClose: false,
        icon: 'warning',
        iconSize: '48px',
        cancelButtonStyle: {
            width: '198px',
            height: '40px',
          },
        confirmButtonStyle: {
          width: '198px',
          height: '40px',
        }

      })
        .then((res) => {
          const param = {
            rtuId: this.selectedDevice.id,
            dimensionId: this.currentNode.id,
            dimensionType: this.dimensionType,
            nodeType: this.currentNode.nodeType,
          }
          return dimensionUnLinkDevice(param);
        })
        .then(() => {
          this.updateSideTree()
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.selectedDevice = {};
        });
    },
    // 能源类型 切换电表、充电站节点显隐字段
    toggleEnergyCols() {
      const value = this.energyForm.nodeType;
      if (value) { // 有节点类型
        this.energyFormOption.column.forEach(col => {
          if ('chargingStation' === value) { // 充电站点
            if (['name', 'nodeType', 'totalChargers', 'totalConnectors', 'totalOutputPower'].includes(col.prop)) {
              col.display = true;
            } else {
              col.display = false;
            }          
          } else { // 电表
            if (['name', 'nodeType', 'sort'].includes(col.prop)) {
              col.display = true;
            } else {
              col.display = false;
            }
          }
        })
      } else { // 无节点类型 默认只展示三项
        this.energyFormOption.column.forEach(col => {
          if (['name', 'nodeType', 'sort'].includes(col.prop)) {
            col.display = true;
          } else {
            col.display = false;
          }
        })
      }
    },
    // 添加环境节点显隐字段
    toggleEnvironmentCols() {
      const value = this.environmentForm.nodeType;
      this.environmentFormOption.column.forEach(col => {
        if (col.prop === 'picture') {
          if (['MainMonitoringZone', 'SubMonitoringZone'].includes(value)) {
            this.environmentForm.xaxis = '';
            this.environmentForm.yaxis = '';
            this.environmentForm.xaxisSub = '';
            this.environmentForm.yaxisSub = '';
            col.display = true;
          } else {
            this.environmentForm.picture = '';
            col.display = false;
          }
        } else if (['mainZone', 'subZone'].includes(col.prop)) {
          if (['MonitoringGroup'].includes(value)) {
            col.display = true;
          } else {
            col.display = false;
          }
        }
      })
    },
    // 添加站点、逆变器显隐字段
    togglePvCols() {
      const value = this.pvForm.nodeType;
      if (value) { // 有节点类型
        this.pvFormOption.column.forEach(col => {
          if ('station' === value) { // 站点
            if (['name', 'nodeType', 'sort', 'assetId', 'capacity', 'inverterCount', 'gridType', 'region', 'address', 'operationDate', 'generationPrice', 'gridElectricity', 'pvBess', 'selfElectricity'].includes(col.prop)) {
              col.display = true;
            } else {
              col.display = false;
            }          
          } else { // 逆变器
            if (['name', 'nodeType', 'capacity', 'ratedOutputPower', 'sort'].includes(col.prop)) {
              col.display = true;
            } else {
              col.display = false;
            }
          }
        })
      } else { // 无节点类型 默认只展示三项
        this.pvFormOption.column.forEach(col => {
          if (['name', 'nodeType', 'sort'].includes(col.prop)) {
            col.display = true;
          } else {
            col.display = false;
          }
        })
      }
    },
    handleUploadUpdate(val) {
      this.environmentForm.picture = val;
    },
    // 确认选择测量点
    onConfirmSelectLinkDevice() {
      const selectedDevice = this.$refs.linkDeviceRef.getSelectedDevice();
      console.log(selectedDevice)
      const item = selectedDevice[0] || {};
      if (!item.id) {
        return this.$message.error(this.Lang.tips.plzSelectOne)
      }
      this.selectedDevice = item;
      const param = {
        rtuId: this.selectedDevice.id,
        dimensionId: this.currentNode.id,
        nodeType: this.dimensionInfo.nodeType,
        dimensionType: this.dimensionType,
        deptId: this.userInfo.dept_id,
      }
      dimensionLinkDevice(param).then(() => {
        this.updateSideTree()
        // this.onLoad(this.page);
        this.$message({
          type: 'success',
          message: this.Lang.tips.operationSuccess,
        });
        this.selectDeviceDialog = false;
      })
    },
    handleDimensionChange(type) {
      this.dimensionType = type;
      this.updateSideTree()
    },
    // 添加、编辑能源节点提交
    handleSubmitEnergy() {
      this.$refs.energyFormRef.validate(valid => {
        if (!valid) return false;
        const params = filterDollarKeys(this.energyForm);
        const submitGroupFn = this.operationType === 'edit' ? updateEnergyDimensionInfo : saveEnergyDimensionInfo;
        submitGroupFn(params).then(
          () => {
            this.updateSideTree()
            this.$message({
              type: 'success',
              message: this.Lang.tips.operationSuccess,
            });
            this.energyDialogBox = false;
          },
          error => {
            window.console.log(error);
          }
        );
      });
    },
    // 添加光伏节点 提交
    handleSubmitPV(form, done) {
      const params = filterDollarKeys(this.pvForm);
      const submitStationFn = this.operationType === 'edit' ? updatePvStationDimensionInfo : savePvStationDimensionInfo;
      if (Array.isArray(params.region)) {
        params.region = params.region.join(',');
      }
      submitStationFn(params).then(
        () => {
          done()
          this.updateSideTree()
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.pvDialogBox = false;
        },
        error => {
          done()
          window.console.log(error);
        }
      );
    },
    submitPvForm() {
      this.$refs.pvFormRef.submit()
    },
    // 添加环境节点 提交
    handleSubmitEnvironment(form, done) {
      const params = filterDollarKeys(this.environmentForm);
      params.xaxis = params.xaxis - 0;
      params.yaxis = params.yaxis - 0;
      params.xaxisSub = params.xaxisSub - 0;
      params.yaxisSub = params.yaxisSub - 0;
      const submitGroupFn = this.operationType === 'edit' ? updateEnvironmentInfo : saveEnvironmentInfo;
      submitGroupFn(params).then(
        () => {
          done()
          this.updateSideTree()
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
          this.environmentDialogBox = false;
        },
        error => {
          done()
          window.console.log(error);
        }
      );
    },
    // 添加底部添加节点
    handleBottomAddNdoe() {
      this.operationType = 'add';
      const isShowEnergy = this.isShowEnergy ? 1 : 0;
      const baseParam = {
        ancestors: this.currentNode.ancestors,
        parentId: this.currentNode.id,
        tenantId: this.userInfo.tenant_id,
        isDept: 0,
        isShowEnergy,
        dimensionType: this.dimensionType,
      };
      if (this.dimensionType == 'AreaEnergy') {
        this.disabledNodeNameOrType('energyFormOption', false)
        this.energyForm = {
          ...baseParam,
          isShowEnergy: 1, // 必须显示
          sort: this.currentNode.sort + 1,
        }
        this.energyDialogBox = true;
        this.toggleEnergyCols();
      } else if (this.dimensionType == 'Environment') {
        this.disabledNodeNameOrType('environmentFormOption', false)
        this.environmentDialogBox = true;
        this.environmentForm = {
          ...baseParam,
          isShowEnergy: 0, // 不显示
          nodeType: '',
          sort: this.currentNode.sort + 1,
        };
        this.toggleEnvironmentCols();
      } else if (this.dimensionType == 'Photovoltaic') {
        this.disabledNodeNameOrType('pvFormOption', false)
        this.pvDialogBox = true;
        this.pvForm = {
          ...baseParam,
          isShowEnergy: 0, // 不显示
          sort: this.currentNode.sort + 1,
        }
        this.togglePvCols();
      }
    },
    // 树右键添加 光伏、区域能源、环境
    handleSideTreeAdd(node) {
      const data = node.data;
      this.parentData = data;
      this.operationType = 'add';
      const isShowEnergy = this.isShowEnergy ? 1 : 0;
      const baseParam = {
        ancestors: data.ancestors,
        parentId: data.id,
        tenantId: this.userInfo.tenant_id,
        isDept: 0,
        isShowEnergy,
        dimensionType: this.dimensionType,
      };
      if (this.dimensionType == 'AreaEnergy') {
        this.disabledNodeNameOrType('energyFormOption', false)
        this.energyForm = {
          ...baseParam,
          isShowEnergy: 1, // 必须显示
          sort: this.currentNode.sort + 1,
        };
        this.energyDialogBox = true;
      } else if (this.dimensionType == 'Environment') {
        this.disabledNodeNameOrType('environmentFormOption', false)
        this.environmentDialogBox = true;
        this.environmentForm = {
          ...baseParam,
          isShowEnergy: 0, // 不显示
          sort: this.currentNode.sort + 1,
        };
      } else if (this.dimensionType == 'Photovoltaic') {
        this.disabledNodeNameOrType('pvFormOption', false)
        this.pvDialogBox = true;
        this.pvForm = {
          ...baseParam,
          isShowEnergy: 0, // 不显示
          sort: this.currentNode.sort + 1,
        }
      }
    },
    // 选择
    handleMoveNodeChange(nodeId, node) {
      const data = node.data;
      if (this.currentNodeParentData.gatewayType == 1) { // 移动网关
        if (data.gatewayType != 1) {
          this.$message.error('Please selet a target gateway group')
          this.currentNodeForm.destinitionId = '';
        }
      }
      if (this.currentNodeParentData.gatewayType == 2) { // 移动设备
        if (data.gatewayType != 2) {
          this.$message.error('Please selet a target gateway')
          this.currentNodeForm.destinitionId = '';
        }
      }
    },
    // 树右键移动节点
    handleClickMoveNode(node, treeData) {
      this.currentNodeForm = {}
      this.currentNodeForm = {
        ...node.data
      }
      this.currentNodeParentData = node.parent?.data || {};
      this.currentNodeGrandParentData = node.parent?.parent?.data || {}
      this.moveToAnOtherNodeBox = true;
    },
    // 树右键移动节点
    handleSubmitMoveNode() {
      const params = {
        id: this.currentNodeForm.id,
        parentId: this.currentNodeForm.destinitionId
      };
      if (!params.parentId) {
        return
      }
      moveDimensionNode(params)
      .then(() => {
        this.$message({
          type: 'success',
          message: this.Lang.tips.operationSuccess,
        });
        this.moveToAnOtherNodeBox = false;
        this.updateSideTree()
        });
    },
    // 编辑
    handleEditNode() {
      this.operationType = 'edit';
      if (this.dimensionType == 'AreaEnergy') {
        this.disabledNodeNameOrType('energyFormOption', true)
        this.energyForm = {
          dimensionType: this.dimensionType,
          ancestors: this.currentNode.ancestors,
          isDept: this.currentNode.isDept,
          parentId: this.currentNode.parentId,
          id: this.currentNode.id,
          sort: this.dimensionInfo.sort,
          nodeType: this.dimensionInfo.nodeType,
          nodeTypeName: this.dimensionInfo.nodeTypeName,
          tenantId: this.dimensionInfo.tenantId,
          name: this.dimensionInfo.name,
          isShowEnergy: 1, // 必须显示
        };
        this.toggleEnergyCols();
        this.energyDialogBox = true;
      } else if (this.dimensionType == 'Environment') {
        this.disabledNodeNameOrType('environmentFormOption', true)
        this.environmentForm = {
          ...this.currentNode,
          sort: this.dimensionInfo.sort,
          dimensionType: this.dimensionType,
        };
        this.environmentForm.xaxis += '';
        this.environmentForm.yaxis += '';
        this.environmentForm.xaxisSub += '';
        this.environmentForm.yaxisSub += '';
        this.toggleEnvironmentCols();
        this.environmentDialogBox = true;
      } else if (this.dimensionType == 'Photovoltaic') {
        this.disabledNodeNameOrType('pvFormOption', true)
        this.pvForm = {
          ...this.currentNode,
          sort: this.dimensionInfo.sort,
          dimensionType: this.dimensionType,
          gridEleItemName: this.dimensionInfo.gridEleItemName,
          gridEleRtuName: this.dimensionInfo.gridEleRtuName,
          pvBessItemName: this.dimensionInfo.pvBessItemName,
          selfEleItemName: this.dimensionInfo.selfEleItemName,
          selfEleRtuName: this.dimensionInfo.selfEleRtuName,
        }
        if (typeof this.pvForm.region === 'string') {
          this.pvForm.region = this.pvForm.region.split(',');
        }
        this.togglePvCols();
        this.pvDialogBox = true;
      }
    },
    disabledNodeNameOrType(formOption, disable) {
      this[formOption].column.forEach(item => {
        if (item.prop == 'name' && this.currentNode.isDept) {
          item.disabled = disable;
        } else {
          item.disabled = false;
        }
      })
      if (disable && this.selectedDevice.sn) { // 只有编辑这里才为true
        // 有绑设备就禁用节点类型编辑
        // this.disabledNodeType(formOption, disable)
        this.disabledNodeType(formOption, false)
      } else {
        this.disabledNodeType(formOption, false)
      }
    },
    disabledNodeType(formOption, disable) {
      this[formOption].column.forEach(item => {
        if (item.prop == 'nodeType') {
          item.disabled = disable;
        } else {
          if (item.prop !== 'name') { // 排除name因为前面已经处理
            item.disabled = false;
          }
        }
      })
    },
    // 删除能源节点
    handleDeleteDimensionNode(node) {
      const data = node.data;
      this.$dialog({
        title: this.Lang.Title.dimensionDelNode,
        titleStyle: 'font-weight:600;margin:10px 0 6px 0;',
        icon: 'danger',
        iconSize: '50px',
        iconColor: '#FEF3F2',
        content: `<div>${this.Lang.Title.dimensionNode}: ${data.name} </div><div style="color:red;margin:8px 0;">${this.Lang.Text.dimensionDelNodeCon}</div>`,
        confirmButtonText: this.Lang.btn.delete,
        cancelButtonText: this.Lang.btn.cancel,
        cancelButtonType: 'delete',
        confirmButtonType: 'danger',
        showClose: false,
      })
        .then(() => {
          return deleteDimensionNode({id: data.id});
        })
        .then(() => {
          this.currentNode = {}
          this.updateSideTree('delete')
          this.$message({
            type: 'success',
            message: this.Lang.tips.operationSuccess,
          });
        });
    },

    // 获取能源维度节点详情
    getDimensionDetail(params) {
      energylDimensionDetail(params).then(res => {
        const data = res.data.data;
        this.currentNode = data.dimensionInfo;
        this.dimensionInfo =  {
          ...data.dimensionInfo,
          dimensionUpdate: data.dimensionUpdate,
        }
        this.selectedDevice = {
          ...data.device,
          deviceUpdate: data.deviceUpdate,
        }
      });
    },
    // 获取环境维度节点详情
    getEnvironmentDimensionDetail(params) {
      detailEnvironmentDimension(params).then(res => {
        const data = res.data.data;
        this.currentNode = data.dimensionInfo;
        this.dimensionInfo =  {
          ...data.dimensionInfo,
          dimensionUpdate: data.dimensionUpdate,
        }
        this.selectedDevice = {
          ...data.device,
          deviceUpdate: data.deviceUpdate,
        }
      });
    },
    // 获取光伏维度节点详情
    getPvDimensionDetail(params) {
      stationDimensionDetail(params).then(res => {
        const data = res.data.data;
        this.currentNode = data.dimensionInfo;
        this.dimensionInfo =  {
          ...data.dimensionInfo,
          dimensionUpdate: data.dimensionUpdate,
        }
        this.selectedDevice = {
          ...data.device,
          deviceUpdate: data.deviceUpdate,
        }
      });
    },
    nodeClick({data, treeData}) {
      this.currentNode = data;
      if (this.dimensionType == 'AreaEnergy') {
        this.getDimensionDetail({id: data.id, nodeType: data.nodeType});
      } else if (this.dimensionType == 'Environment') {
        this.getEnvironmentDimensionDetail({id: data.id, nodeType: data.nodeType});
      } else if (this.dimensionType == 'Photovoltaic') {
        this.getPvDimensionDetail({id: data.id, nodeType: data.nodeType});
      }
      // this.onLoad(this.page, { deviceId: data.id });
    },
    handleOrganizationChange(id) {
      this.organization = id;
      this.updateSideTree()
    },
    updateSideTree(type) {
      const tenantId = this.userInfo.tenant_id;
      const param = {dimensionType: this.dimensionType, tenantId}
      if (this.organization) {
        param.deptId = this.organization;
      }
      dimensionTree(param).then(res => {
        const data = res.data.data;
        this.treeData = data; // 组件自己点击
        this.$nextTick(() => {
          if (type == 'delete') {
            this.currentNode = this.treeData[0];
            this.handleClickFirstNode(this.treeData[0]);
          } else {
            this.handleClickFirstNode();
          }
        })
      }).catch(e => {
        if (/localhost:2888/g.test(location.origin)) {
          // this.setTestTreeData()
        }
      })
    },
    initData() {
      this.updateSideTree();
    },
    handleClickFirstNode(nodeData) {
      const tree = this.$refs.treeRef;
      if (tree) {
        if (nodeData) {
          tree.updateCurrentNode(nodeData)
        }
        tree.autoClickFirstNode(nodeData)
      }
    },
    // onLoad(page, params = {}) {
    //   this.refreshIng = true;
    //   setTimeout(() => {
    //     this.refreshIng = false;
    //   }, 1000)
    //   this.loading = true;
    //   params.deviceId = this.deviceId;
    //   params.rtuId = this.rtuId;
    //   getDevicePage(
    //     page.currentPage,
    //     page.pageSize,
    //     Object.assign(this.query, params,{ status: this.auditMode ? 0 : 1 })
    //   ).then(res => {
    //     const data = res.data.data || {};
    //     this.lastUpdateTime = data.lastUpdateTime;
    //     this.page.total = data.pages.total;
    //     const records = data.pages.records;
    //     records.map(item => {
    //       item.isStorage = !!item.store;
    //     })
    //     this.loading = false;
    //   });
    // },
  },
};
</script>

<style lang="scss" scoped>

</style>
